import { Link } from 'react-router-dom';
import logoLockup from '../../assets/icons/cabana-logo.png';
import logoMark from '../../assets/icons/cabana-logomark.png';
import './Logo.css';

interface LogoProps {
  /** Collapsed sidebar → render the wave mark only. Default renders the full lockup. */
  collapsed?: boolean;
}

/**
 * Brand logo. These assets are the WHITE/grayscale variant — they only read on
 * dark surfaces, so the Logo must sit on dark chrome (sidebar/header backed by
 * --color-marine / --color-tide). Never place it on a light surface.
 * Only the white/grayscale variant exists. There is no light-surface version, which
 * is why the constraint above is absolute rather than stylistic.
 */
export function Logo({ collapsed = false }: LogoProps) {
  return (
    <Link className="logo" to="/" aria-label="Cabana Air Filters — home">
      {collapsed ? (
        <img className="logo__img logo__img--mark" src={logoMark} alt="Cabana" />
      ) : (
        <img className="logo__img logo__img--lockup" src={logoLockup} alt="Cabana Air Filters" />
      )}
    </Link>
  );
}
